import React, { useMemo } from "react";

import DashboardWidgetCard from "./components/DashboardWidgetCard";
import DashboardCardHeader from "./components/DashboardCardHeader";
import HeaderAndValue from "./components/HeaderAndValue";

import { makeStyles } from "@material-ui/core";
import ToggleButtonsTrasnferList from "./components/ToggleButton";
import useFaceMatchFetch from "./hooks/useFaceMatchFetch";
import Loading from "./components/Loading";
import { formattedDate, formatToCommaString } from "./helper/format";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { CalendarMonth, ExpandMore } from "@mui/icons-material";
import { ExpandLess } from "@material-ui/icons";

const useStyle = makeStyles((theme) => {
  return {
    card: { margin: theme.spacing(2, 0) },
    cardHeader: {
      margin: theme.spacing(0, 1.5, 1.5),
    },
    cardSubheader: {
      fontSize: 12,
      fontWeight: 500,
      opacity: 0.56,
      marginTop: theme.spacing(-1),
    },
    container: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
      },
    },
    widget: {
      background: "white",
      borderRadius: theme.spacing(1.5),
      margin: theme.spacing(0, 1, 1),
      width: "calc(25% - 8px)",
      textAlign: "center",
      padding: theme.spacing(2),
      [theme.breakpoints.down("md")]: {
        width: "calc(50% - 16px)",
      },
      display: "flex",
      flexDirection: "column",
    },
    headerActions: {
      display: "flex",
      flexDirection: "column",
      alignItems: "end",
    },
    datePicker: {
      backgroundColor: "white",
      borderRadius: "32px",
      display: "flex",
      justifyContent: "center",
      alignItems: "end",
      marginBottom: 8,
      width: "fit-content",
      padding: "8px 20px",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      color: "rgba(54, 43, 115, 0.56)",
      cursor: "pointer",
      fontSize: 13,
      fontWeight: 500,
    },
  };
});

const config = (data) => [
  {
    label: "Attendance %",
    value: data.attendancePercentage,
    styles: { valueClass: { color: "rgba(226, 19, 110, 1)" } },
  },
  {
    label: "Required Attendance",
    value: formatToCommaString(data.totalEmployeeCount),
    subValue: `Out of ${formatToCommaString(
      data.totalActiveEmployeeCount
    )} active Employees`,
  },
  {
    label: "Attendance",
    value: formatToCommaString(data.presentEmployeeCount),
    // subValue: `+ ${formatToCommaString(
    //   data.suspiciousEmployeeCount
    // )} On Leave But Present`,
  },
  { label: "Absent", value: formatToCommaString(data.absentEmployeeCount) },
];

const tabConfig = [
  { label: "Overall", id: "" },
  { label: "TM", id: "TM" },
  { label: "OM", id: "OM" },
  { label: "FSE", id: "FSE" },
  { label: "MDO", id: "MDO" },
  { label: "MMO", id: "MMO" },
  { label: "MAO", id: "MAO" },
];

export default function AttendenceOverview({ geoFilters }) {
  const classes = useStyle();
  const [tabIndex, setTabIndex] = React.useState(0);
  const [dateValue, onDateChange] = React.useState(new Date());
  const [isCalanderOpen, setCalanderOpen] = React.useState(false);
  const onTabChange = (index) =>
    setTabIndex((prev) => (index == null ? prev : index));

  const params = useMemo(() => {
    return {
      ...geoFilters,
      userCategory: tabConfig[tabIndex].id,
      appName: "nimontron",
      date: dateValue.toISOString(),
    };
  }, [dateValue, geoFilters, tabIndex]);

  const { data, isLoading } = useFaceMatchFetch(
    "/report/daily-attendance-overview",
    params
  );

  return (
    <DashboardWidgetCard className={classes.card}>
      <DashboardCardHeader
        className={classes.cardHeader}
        label={
          <>
            Attendence overview <br />
            <span className={classes.cardSubheader}>
              *Based on today’s Face-Matching attendance
            </span>
          </>
        }
      >
        <div className={classes.headerActions}>
          <div
            className={classes.datePicker}
            onClick={() => setCalanderOpen((prev) => !prev)}
          >
            <DatePicker
              isOpen={isCalanderOpen}
              calendarIcon={null}
              onChange={onDateChange}
              value={dateValue}
            />
            <CalendarMonth />
            <span style={{ margin: "0 16px" }}>{formattedDate(dateValue)}</span>
            {isCalanderOpen ? <ExpandLess /> : <ExpandMore />}
          </div>
          <ToggleButtonsTrasnferList
            config={tabConfig}
            {...{ tabIndex, onTabChange }}
          />
        </div>
      </DashboardCardHeader>
      {isLoading ? (
        <Loading />
      ) : (
        data && (
          <div className={classes.container}>
            {config(data).map((c) => {
              return (
                <div className={classes.widget} key={c.label}>
                  <HeaderAndValue
                    {...c}
                    styles={{
                      valueClass: {
                        display: "flex",
                        flexDirection: "column",
                      },
                      subValueClass: {
                        color: "rgba(99, 99, 99, 1)",
                        fontWeight: 400,
                        fontSize: 12,
                      },
                    }}
                  />
                </div>
              );
            })}
          </div>
        )
      )}
    </DashboardWidgetCard>
  );
}
